<template>
  <el-dialog
    class="subscribe-spv-node common-dialog"
    title="订阅SPV节点"
    :visible.sync="showDialog"
    top="33vh"
    @open="onShow"
    @closed="onClosed"
  >
    <el-alert
      title="请使用实际部署时的地址和端口进行订阅"
      type="info"
      show-icon
      :closable="false"
    ></el-alert>
    <el-form
      ref="subscribeSpvNode"
      :model="model"
      :rules="rules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
    >
      <el-form-item label="IP地址" prop="serverIP">
        <el-input v-model="model.serverIP" placeholder="请输入IP地址"></el-input>
      </el-form-item>
      <el-form-item label="Web端口" prop="webPort">
        <el-input v-model="model.webPort" placeholder="请输入Web端口"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cacel">取 消</el-button>
      <el-button type="primary" @click="makeSure">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import adaptation from '@/mixins/adaptation'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'SubscribeSpvNode',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 140
  },
  props: {
    dialogVisible: Boolean,
    handleInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    let validateAddr = (rule, value, callback) => {
      let reg = /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/
      if (value === '') {
        callback(new Error('请输入IP地址'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的IP地址'))
      } else {
        callback()
      }
    }
    let validateWebPort = (rule, value, callback) => {
      let reg = /^\d+$/
      if (value === '') {
        callback(new Error('请输入Web端口'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的Web端口'))
      } else {
        callback()
      }
    }
    return {
      model: {
        serverIP: null,
        webPort: null
      },
      rules: {
        serverIP: [{ required: true, validator: validateAddr, trigger: ['blur', 'change'] }],
        webPort: [{ required: true, validator: validateWebPort, trigger: ['blur', 'change'] }]
      },
      showDialog: false,
      adaptationVars: {
        formLabelWidth: 140
      }
    }
  },
  watch: {
    dialogVisible: function(val) {
      this.showDialog = val
    },
    showDialog: function(val) {
      this.$emit('update:dialogVisible', val)
    }
  },
  mounted() {},
  methods: {
    cacel() {
      this.showDialog = false
    },
    makeSure() {
      let self = this
      this.$refs.subscribeSpvNode.validate(valid => {
        if (valid) {
          console.log('submit!')

          self.$apis.spvlightnodes
            .subscribeSpvNode({
              spvId: self.handleInfo.id,
              serverIP: self.model.serverIP,
              webPort: parseInt(self.model.webPort)
            })
            .then(res => {
              if (res && !res.errors) {
                self.showDialog = false

                self.$emit('subscribeSuccess')
                self.$message({
                  type: 'success',
                  message: '订阅SPV节点成功!'
                })
              } else {
                self.$message({
                  type: 'error',
                  message: '订阅SPV节点失败!'
                })
              }
              console.log(res)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    onShow() {
      this.model.serverIP = this.handleInfo.serverIP
      this.model.webPort = this.handleInfo.webPort
    },
    onClosed() {
      this.$refs.subscribeSpvNode.clearValidate()
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('subscribe-spv-node', (), ());
.subscribe-spv-node {
  @include adaptation((
    --subscribe-alert-width: 490px,
    --subscribe-alert-margin-bottom: 18px,
    --subscribe-alert-margin-left: 60px,

  ));
  /deep/ .el-dialog {
    width: var(--common-dialog-medium-width);

    .el-alert {
      width: var(--subscribe-alert-width);
      margin-bottom: var(--subscribe-alert-margin-bottom);
      margin-left: var(--subscribe-alert-margin-left);
    }
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }
}
</style>
